import { FieldValues } from 'react-hook-form'

import { EmployeePayrollRunElementEditCompensationsFormFragment } from 'generated/resources/graphql'

import { fromCents, toCents } from 'modules/core/lib/formatCurrencyUtils'

const mapCompensationAmountsFromCents = <
  TFieldValues extends EmployeePayrollRunElementEditCompensationsFormFragment
>(
  employeePayrollRunElementEditCompensationsForm: TFieldValues
): TFieldValues => {
  const nodes = employeePayrollRunElementEditCompensationsForm.nodes.map((node) => {
    const {
      isOverridden,
      amount: originalAmount,
      compensationsAmountStrategy,
      payrollConcept,
    } = node

    if (payrollConcept?.unitType !== 'money') {
      return node
    }

    const originalAmountStrategy = compensationsAmountStrategy
    const amount = isOverridden ? originalAmount : compensationsAmountStrategy?.amount
    const amountFromCents = amount !== null && amount !== undefined ? fromCents(amount) : null
    return {
      ...node,
      amount: isOverridden ? amountFromCents : null,
      compensationsAmountStrategy: originalAmountStrategy
        ? {
            ...originalAmountStrategy,
            amount: !isOverridden ? amountFromCents : null,
          }
        : null,
    }
  })
  return {
    ...employeePayrollRunElementEditCompensationsForm,
    nodes,
  }
}

const mapAmountFromCents = <TFieldValues extends FieldValues>(
  compensation: TFieldValues
): TFieldValues => {
  const {
    isOverridden,
    amount: originalAmount,
    compensationsAmountStrategy,
    payrollConcept,
  } = compensation
  if (payrollConcept?.unitType !== 'money') {
    return compensation
  }
  const originalAmountStrategy = compensationsAmountStrategy
  const amount = isOverridden ? originalAmount : compensationsAmountStrategy?.amount
  const amountFromCents = amount !== null && amount !== undefined ? fromCents(amount) : null
  return {
    ...compensation,
    amount: isOverridden ? amountFromCents : null,
    compensationsAmountStrategy: originalAmountStrategy
      ? {
          ...originalAmountStrategy,
          amount: !isOverridden ? amountFromCents : null,
        }
      : null,
  }
}

const mapAmountToCents = <TFieldValues extends FieldValues>(
  compensation: TFieldValues
): TFieldValues => {
  const {
    isOverridden,
    amount: originalAmount,
    compensationsAmountStrategy,
    payrollConcept,
  } = compensation
  const isMoney = payrollConcept?.unitType === 'money'
  const originalAmountStrategy = compensationsAmountStrategy
  const amount = isOverridden ? originalAmount : compensationsAmountStrategy?.amount
  const amountFromCents =
    amount !== null && amount !== undefined ? (isMoney ? toCents(amount) : amount) : null
  return {
    ...compensation,
    amount: isOverridden ? amountFromCents : null,
    compensationsAmountStrategy: originalAmountStrategy
      ? {
          ...originalAmountStrategy,
          amount: !isOverridden ? amountFromCents : null,
        }
      : null,
  }
}

export { mapCompensationAmountsFromCents, mapAmountFromCents, mapAmountToCents }
